import type { ReactNode } from 'react';

import { classFor } from '../lib/class-map';
import { cn } from '../lib/cn';

import s from './StatusBanner.module.css';
import { TONE_ICON_PATHS, TONE_ROLE, type Tone } from './tone-icons';

interface StatusBannerProps {
  tone: Tone;
  children: ReactNode;
  className?: string;
  id?: string;
}

const TONE_CLASS: Record<Tone, string> = {
  success: s.success ?? '',
  error: s.error ?? '',
  warning: s.warning ?? '',
  info: s.info ?? '',
};

export function StatusBanner({ tone, children, className, id }: StatusBannerProps): JSX.Element {
  return (
    <div
      id={id}
      role={classFor(TONE_ROLE, tone)}
      className={cn(s.root, classFor(TONE_CLASS, tone), className)}
    >
      <svg
        className={s.icon}
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d={classFor(TONE_ICON_PATHS, tone)} />
      </svg>
      <div className={s.body}>{children}</div>
    </div>
  );
}
